import React, { useContext, useEffect, useState } from "react";
import UiUtils from "../../utils/UiUtils";
import ApiClient from "../../utils/ApiClient";
import FormCampaña from "../campaña/FormCambaña";
import { getClientId, hashh } from "../api";
import DashboardNav from "./components/navbar/Navbar";
import { UserContext } from "../../context/UserContext";

const MainDash = (props) => {
    const [error, setError] = useState();


    const { setUser,user } = useContext(UserContext);

    useEffect(() => {
        getData();
    }, []);

    function getData() {
        getClientId()
        .then(res=>{
          setUser({idCliente:res.data})
        })
        .catch(err=>{
          setError(err)
          UiUtils.showError(err)
        })
    }

    return (
        <div>
            <DashboardNav />
            <FormCampaña id={user.idCliente} />
        </div>
    );
};

export default MainDash;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/MainDash.js